import {
  ContainerOutlined,
  DeploymentUnitOutlined,
  RedEnvelopeOutlined,
  EditOutlined,
  FacebookOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  GoogleOutlined,
  HomeOutlined,
  ProfileOutlined,
  ShopOutlined,
  StarOutlined,
  UserAddOutlined,
  ZoomInOutlined,
  DotChartOutlined,
  DiffOutlined,
  FormOutlined,
  UserSwitchOutlined,
  PictureOutlined,
  FileSearchOutlined,
  CrownOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
  AreaChartOutlined,
  AppstoreAddOutlined,
  FilePdfOutlined,
  VideoCameraAddOutlined,
  QuestionCircleOutlined,
  AppstoreOutlined,
  CarryOutOutlined,
  ControlOutlined,
  FileSyncOutlined,
  DeliveredProcedureOutlined,
  SendOutlined,
  NotificationOutlined,
  AlertOutlined,
  AuditOutlined,
} from "@ant-design/icons";

//FontAwesomeIcon
import {
  faUserLock,
  faList,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
// TODO replace faTripadvisor
import { faYelp } from "@fortawesome/free-brands-svg-icons";

export const navLinks = [
  {
    tooltip: "dashboard",
    logo: HomeOutlined,
    link: "/",
    title: "Dashboard",
    testDataId: "dashboard",
    subMenu: [],
  },
  {
    tooltip: "hmg-manager",
    logo: CrownOutlined,
    title: "Hotel Management Group",
    permission: "sm_solution_access",
    testDataId: "hmg-manager",
    subMenu: [
      {
        tooltip: "hmg-create",
        logo: EditOutlined,
        link: "/hmg-create",
        title: "Create and Update",
        testDataId: "hmg-create",
        subMenu: [],
      },
      {
        tooltip: "hmg-view",
        logo: ZoomInOutlined,
        link: "/hmg-manager",
        title: "View",
        testDataId: "hmg-view",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "project-manager",
    logo: DeploymentUnitOutlined,
    title: "Projects",
    permission: "sm_solution_access",
    testDataId: "project-manager",
    subMenu: [
      {
        tooltip: "project-create",
        logo: EditOutlined,
        link: "/project-create",
        title: "Create and Update",
        testDataId: "project-create",
        subMenu: [],
      },
      {
        tooltip: "project-view",
        logo: ZoomInOutlined,
        link: "/project-manager",
        title: "View",
        testDataId: "project-view",
        subMenu: [],
      },
      {
        tooltip: "app-configuration",
        logo: ProfileOutlined,
        link: "/app-configuration",
        title: "App Configurations",
        testDataId: "app-configuration",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "hotel-manager-sub-menu",
    logo: ShopOutlined,
    title: "Hotels",
    permission: "sm_solution_access",
    testDataId: "hotel-manager-sub-menu",
    subMenu: [
      {
        tooltip: "hotel-create",
        logo: EditOutlined,
        link: "/hotel-create",
        title: "Create and Update",
        testDataId: "hotel-create",
        subMenu: [],
      },
      {
        tooltip: "hotel-manager",
        logo: ZoomInOutlined,
        link: "/hotel-manager",
        title: "View",
        testDataId: "hotel-manager",
        subMenu: [],
      },
      {
        tooltip: "bulk-hotel-upload",
        logo: "",
        faIcon: faFileExcel,
        link: "/bulk-hotel-creation",
        title: "Bulk Hotel Creation",
        testDataId: "bulk-hotel-upload",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "user_management",
    logo: UserAddOutlined,
    title: "User Management",
    permission: "sm_user_managment",
    testDataId: "user_management",
    subMenu: [
      {
        tooltip: "user-create",
        logo: EditOutlined,
        link: "/user-create",
        title: "Create",
        testDataId: "user-create",
        subMenu: [],
      },
      {
        tooltip: "user-manager",
        logo: ZoomInOutlined,
        link: "/user-manager",
        title: "View and Update",
        testDataId: "user-manager",
        subMenu: [],
      },
      {
        tooltip: "bulk-user-creation",
        logo: "",
        faIcon: faFileExcel,
        link: "/bulk-user-creation",
        title: "Bulk User Creation",
        testDataId: "bulk-user-creation",
        subMenu: [],
      },
      {
        tooltip: "main-roles-manager",
        logo: "",
        faIcon: faUserLock,
        link: "/main-roles-manager",
        title: "Main Roles Manager",
        permission: "sm_solution_access",
        testDataId: "main-roles-manager",
        subMenu: [],
      },
      {
        tooltip: "role_creation",
        logo: "",
        faIcon: faUserLock,
        link: "/role-manager",
        title: "Role Permission",
        permission: "sm_solution_access",
        testDataId: "role_creation",
        subMenu: [],
      },
      {
        tooltip: "user_permission",
        logo: "",
        faIcon: faUserLock,
        link: "/user-permission",
        title: "User Permission",
        permission: "sm_solution_access",
        testDataId: "user_permission",
        subMenu: [],
      },
      {
        tooltip: "role-app-config-manager",
        logo: ControlOutlined,
        link: "/role-app-config-manager",
        permission: "sm_solution_access",
        title: "Role App Config",
        testDataId: "role-app-config-manager",
        subMenu: [],
      },
      {
        tooltip: "user-app-config-manager",
        logo: ControlOutlined,
        link: "/user-app-config-manager",
        title: "User App Config",
        permission: "sm_solution_access",
        testDataId: "user-app-config-manager",
        subMenu: [],
      },
      {
        tooltip: "logged_user_details",
        logo: UserSwitchOutlined,
        link: "/logged_user_details",
        title: "User Logged Details",
        permission: "sm_solution_access",
        testDataId: "logged_user_details",
        subMenu: [],
      },
      {
        tooltip: "user-invitation",
        logo: SendOutlined,
        link: "/user-invitation",
        title: "User Invitation",
        permission: "sm_solution_access",
        testDataId: "user-invitation",
        subMenu: [],
      },
      {
        tooltip: "sso-integration",
        logo: ControlOutlined,
        link: "/sso-integration",
        title: "SSO Integration",
        permission: "sm_solution_access",
        testDataId: "sso-integration",
        subMenu: [],
      },

      // {
      //   tooltip: "advance-search",
      //   logo: FileSearchOutlined,

      //   title: "Advance Search",
      //   permission: "sm_user_managment",
      //   subMenu: [
      //     {
      //       tooltip: "report_create",
      //       logo: UserSwitchOutlined,
      //       link: "/advance-search/user",
      //       title: "Users",
      //       subMenu: [],
      //     },
      //   ],
      // },
    ],
  },
  {
    tooltip: "secondary-envelope",
    logo: FileDoneOutlined,
    link: "/secondary-envelope",
    title: "Secondary Envelope",
    permission: "sm_solution_access",
    subMenu: [],
    testDataId: "secondary-envelope",
    platformType: "MARRIOTT", //shows up in marriott only
  },
  {
    tooltip: "envelope-signers",
    logo: FileDoneOutlined,
    link: "/envelope-signers",
    title: "Envelope Signers",
    permission: "sm_solution_access",
    testDataId: "envelope-signers",
    subMenu: [],
  },
  {
    tooltip: "envelop-info",
    logo: RedEnvelopeOutlined,
    title: "Envelope Info",
    permission: "sm_solution_access",
    testDataId: "envelop-info",
    subMenu: [
      {
        tooltip: "envelop-trigger",
        logo: EditOutlined,
        link: "/envelop-trigger",
        title: "Envelope Trigger",
        testDataId: "envelop-trigger",
        subMenu: [],
      },
      {
        tooltip: "signature-qc",
        logo: EditOutlined,
        link: "/signature-qc",
        title: "Signature QC",
        testDataId: "signature-qc",
        subMenu: [],
      },
      {
        tooltip: "environ-impact",
        logo: PictureOutlined,
        link: "/environ-impact",
        title: "Environmental Impact",
        testDataId: "environ-impact",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "pms-manager-sub-menu",
    logo: DotChartOutlined,
    permission: "sm_solution_access",
    title: "PMS Manager",
    testDataId: "pms-manager-sub-menu",
    subMenu: [
      {
        tooltip: "pms-create",
        logo: EditOutlined,
        link: "/pms-create",
        title: "Create and Update",
        testDataId: "pms-create",
        subMenu: [],
      },
      {
        tooltip: "pms-manager",
        logo: ZoomInOutlined,
        link: "/pms-manager",
        title: "View",
        testDataId: "pms-manager",
        subMenu: [],
      },
      {
        tooltip: "pms-report-list",
        logo: ZoomInOutlined,
        link: "/pms/report-list",
        title: "Standard Report List",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "hotel_reviews",
    logo: StarOutlined,
    title: "Hotel Reviews",
    permission: "sm_solution_access",
    testDataId: "hotel_reviews",
    subMenu: [
      {
        tooltip: "FacebookPage",
        logo: FacebookOutlined,
        link: "/hotel-reviews/facebook-page",
        title: "Facebook Page",
        testDataId: "facebook-page",
        subMenu: [],
      },
      {
        tooltip: "GooglePlace",
        logo: GoogleOutlined,
        link: "/hotel-reviews/google-place",
        title: "Google Place",
        testDataId: "google-place",
        subMenu: [],
      },
      {
        tooltip: "TripAdvisor",
        logo: "",
        faIcon: faYelp,
        link: "/hotel-reviews/trip-advisor",
        title: "TripAdvisor",
        testDataId: "trip-advisor",
        subMenu: [],
      },
      {
        tooltip: "YelpPage",
        logo: "",
        faIcon: faYelp,
        link: "/hotel-reviews/yelp-page",
        title: "Yelp Page",
        testDataId: "yelp-page",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "report_category_view",
    logo: FormOutlined,
    link: "/report-category/view",
    title: "Report Category Management",
    testDataId: "report-category-view",
    permission: "sm_report_category",
    subMenu: [],
  },
  {
    tooltip: "qc-summary",
    logo: AuditOutlined,
    title: "QC Summary",
    permission: "sm_solution_access",
    testDataId: "qc-summary",
    subMenu: [
      {
        tooltip: "report_qc",
        logo: EditOutlined,
        link: "/report-management/report-qc",
        title: "Group QC (Ad hoc)",
        testDataId: "report-qc",
        permission: "sm_solution_access",
        subMenu: [],
      },
      {
        tooltip: "hotel_qc",
        logo: EditOutlined,
        link: "/report-management/hotel-qc",
        title: "Hotel QC (Ad hoc)",
        testDataId: "hotel-qc",
        permission: "sm_solution_access",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "report-management",
    logo: ContainerOutlined,
    title: "Report Management",
    testDataId: "report-management",
    permission: "sm_report_management",
    subMenu: [
      {
        tooltip: "report-management-dashboard",
        logo: ZoomInOutlined,
        link: "/report-management/view",
        title: "Dashboard",
        testDataId: "report-management-dashboard",
        subMenu: [],
      },
      {
        tooltip: "report-management-bulk-home",
        logo: "",
        faIcon: faFileExcel,
        link: "/report-management/bulk",
        title: "Bulk Edit",
        testDataId: "report-management-bulk-home",
        subMenu: [],
      },
      {
        tooltip: "report-management-additional-reports",
        logo: EditOutlined,
        link: "/report-management/additional-reports",
        title: "Add Additional Reports",
        testDataId: "report-management-additional-reports",
        subMenu: [],
      },
      {
        tooltip: "report-management-bulk-delete",
        logo: DiffOutlined,
        link: "/report-management/bulk-delete",
        title: "Bulk Report Delete",
        permission: "sm_report_delete",
        testDataId: "report-management-bulk-delete",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "file_mapping",
    logo: FileSearchOutlined,
    title: "Report and File Mapping",
    permission: "sm_solution_access",
    testDataId: "file-mapping",
    subMenu: [
      {
        tooltip: "bulk_file_names",
        title: "Bulk File Mapping",
        testDataId: "bulk-file-names",
        subMenu: [
          {
            tooltip: "create",
            logo: EditOutlined,
            link: "/bulkfilemapping/create",
            title: "Create",
            testDataId: "bulk-file-create",
            subMenu: [],
          },
          {
            tooltip: "",
            logo: ZoomInOutlined,
            link: "/bulkfilemapping/view",
            title: "View and Update",
            testDataId: "view-and-update",
            subMenu: [],
          },
        ],
      },
    ],
  },
  {
    tooltip: "index",
    logo: "",
    faIcon: faList,
    permission: "sm_solution_access",
    title: "Index Management",
    testDataId: "index",
    subMenu: [
      {
        tooltip: "index-create",
        logo: EditOutlined,
        link: "/index/create",
        title: "Create",
        testDataId: "index-create",
        subMenu: [],
      },
      {
        tooltip: "index-view",
        logo: ZoomInOutlined,
        link: "/index/view",
        title: "View and Update",
        testDataId: "index-view",
        subMenu: [],
      },
      {
        tooltip: "index-mapping",
        logo: ProfileOutlined,
        link: "/index/mapping",
        title: "Index Auto Populate",
        testDataId: "index-mapping",
        subMenu: [],
      },
    ],
  },
  // {
  //   tooltip: "barcode-management",
  //   logo: FilePdfOutlined,
  //   link: "/barcode-management",
  //   title: "Barcode Management",
  //   testDataId: "barcode-management",
  //   permission: "sm_barcode_management",
  //   subMenu: [],
  // },

  {
    tooltip: "file-upload",
    logo: CloudUploadOutlined,
    title: "File Upload",
    permission: "sm_solution_access",
    testDataId: "file-upload",
    subMenu: [
      // {
      //   tooltip: "trainingm-upload",
      //   logo: VideoCameraAddOutlined,
      //   link: "/file-upload/trainingm-upload",
      //   title: "Training Materials Upload",
      //   testDataId: "trainingm-upload",
      //   subMenu: [],
      // },
      {
        tooltip: "faqs",
        logo: QuestionCircleOutlined,
        link: "/file-upload/faqs",
        title: "FAQs",
        testDataId: "faqs",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "statistics",
    logo: AreaChartOutlined,
    title: "Statistics",
    permission: "sm_solution_access",
    testDataId: "statistics",
    subMenu: [
      {
        tooltip: "app-clicked-statistics",
        logo: AppstoreAddOutlined,
        link: "/statistics/app-clicked-statistics",
        title: "App Clicked Statistics",
        testDataId: "app-clicked-statistics",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "applications",
    logo: AppstoreOutlined,
    title: "Applications",
    permission: "sm_solution_access",
    testDataId: "applications",
    subMenu: [
      {
        tooltip: "default-app-configs",
        logo: CarryOutOutlined,
        link: "/applications/default",
        title: "Default App Settings",
        testDataId: "default-app-configs",
        subMenu: [],
      },
      {
        tooltip: "default-index-settings",
        logo: CarryOutOutlined,
        link: "/applications/default-index-settings",
        title: "Default Index Settings",
        subMenu: [],
      },
      {
        tooltip: "default-index-order-settings",
        logo: CarryOutOutlined,
        link: "/applications/default-index-order-settings",
        title: "Default Index Order Settings",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "SftpUI",
    logo: FileSyncOutlined,
    title: "File Transfer",
    permission: "sm_solution_access",
    testDataId: "sftp-ui",
    subMenu: [
      {
        tooltip: "ConnectionConfigurationForm",
        logo: EditOutlined,
        link: "/file-transfer/connection-configuration-form",
        title: "Connection Configuration",
        testDataId: "connection-configuration-form",
        subMenu: [],
      },
      {
        tooltip: "ViewSFTPConnections",
        logo: ZoomInOutlined,
        link: "/file-transfer/sftp-connections-view",
        title: "View Connection",
        testDataId: "view-sftp-connections",
        subMenu: [],
      },
      {
        tooltip: "AutomatedJobsConfigurationForm",
        logo: EditOutlined,
        link: "/file-transfer/automated-job-configuration-form",
        title: "Jobs Configuration",
        testDataId: "automated-jobs-configuration-form",
        subMenu: [],
      },
      {
        tooltip: "ViewSFTPJobs",
        logo: ZoomInOutlined,
        link: "/file-transfer/sftp-job-view",
        title: "View Job",
        testDataId: "view-sftp-jobs",
        subMenu: [],
      },
      {
        tooltip: "Log",
        logo: ControlOutlined,
        link: "/file-transfer/sftp-log",
        title: "View Log",
        testDataId: "log",
        subMenu: [],
      },
      {
        tooltip: "manualJobExecutionForm",
        logo: DeliveredProcedureOutlined,
        link: "/file-transfer/manual-job-execution-form",
        title: "Manual Job Execution",
        testDataId: "manual-job-execution-form",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "notifications-and-alerts",
    logo: NotificationOutlined,
    title: "Notifications & Alerts",
    permission: "sm_solution_access",
    testDataId: "notifications-and-alerts",
    subMenu: [
      {
        tooltip: "Reminder",
        logo: AlertOutlined,
        link: "/notification-schedules/reminders",
        title: "Reminders",
        permission: "sm_solution_access",
        testDataId: "reminders",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "role-management",
    faIcon: faUserLock,
    title: "Role Management",
    permission: "sm_solution_access",
    testDataId: "role-management",
    subMenu: [
      {
        tooltip: "hmg-role-mapping",
        faIcon: faUserLock,
        link: "/hmg-role-mapping",
        title: "HMG Role Mapping",
        testDataId: "hmg-role-mapping",
        subMenu: [],
      },
    ],
  },
  {
    tooltip: "onboarding",
    faIcon: faUserLock,
    title: "Onboarding",
    permission: "sm_onboarding_automation",
    subMenu: [
      {
        tooltip: "onboarding-home-page",
        faIcon: faUserLock,
        link: "/onboarding/dashboard",
        title: "Home Page",
        subMenu: [],
      },
    ],
  },
];

export default navLinks;
